import React, { useState, useEffect } from 'react'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import CardActionArea from '@material-ui/core/CardActionArea'
import { connect } from "react-redux"
import CardContent from '@material-ui/core/CardContent'
import Input from '@material-ui/core/Input'
import TopBarNav from '../common/TopBarNav'
import { useHistory } from 'react-router-dom'
import { MaintenanceStylesComplement } from './MaintenanceStyles'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import DeleteIcon from "@material-ui/icons/Delete"
import IconButton from '@material-ui/core/IconButton'
import CancelIcon from "@material-ui/icons/Cancel"
import CheckCircleIcon from "@material-ui/icons/CheckCircle"
import DataTable from 'react-data-table-component'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import * as maintenanceActions from '../../actions/maintenance/MaintenanceActions'
import { bindActionCreators } from 'redux'
import * as navigationActions from '../../actions/common/NavigationActions'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import { getInvoiceComplementTableColumns } from '../common/Utils'
import { Backdrop, CircularProgress } from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'

const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de', selectAllRowsItem: true, selectAllRowsItemText: 'Todos' }

const MaintenanceUploadComplement = ({ classes, ...props }) => {
    const history = useHistory()
    const [file, setFile] = useState()
    const [nameComplement, setNameComplement] = useState('')
    const [statusNameComplementHidden, setStatusNameComplementHidden] = useState(true)
    const { match: { params } } = props

    const [errorComplementHidden, setErrorComplementHidden] = useState(true)
    const [errorComplementText, setErrorComplementText] = useState('')
    const [successComplementHidden, setSuccessComplementHidden] = useState(true)
    const [successComplementList, setSuccessComplementList] = useState('')

    const [statusGridComplement, setStatusGridComplement] = useState(false)
    const [statusGridInvoice, setStatusGridInvoice] = useState(true)
    const [buttonComplement, setButtonComplement] = useState(classes.GridBorderSelected)
    const [buttonInvoice, setButtonInvoice] = useState(classes.GridBorder)
    const [textComplement, setComplement] = useState(classes.TextSelected)
    const [textInvoice, setInvoice] = useState(classes.Text)
    const [disabledUploadComplement, setDisabledUploadComplement] = useState(false)
    const [openBackdrop, setOpenBackdrop] = useState(false)
    const [missingComplements, setMissingComplements] = useState(true)
    const [missingComplementsGrid, setMissingComplementsGrid] = useState(false)

    useEffect(() => {
        handleOpenBackdrop()
        const newRoute = {
            path: '/maintenance/UploadComplement',
            linkLegend: 'Subir Complemento',
            urlParams: [{ key: 'orderId', value: params.orderId }]
        }
        props.navigationActions.add_route(newRoute)
        props.actions.fetch_Order_Detail(props.userLanguage, props.userToken, params.orderId, onError, onSuccessFetch)
        return () => {
            props.cleanUserProfile()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        handleOpenBackdrop()
        props.actions.fetch_Invoice_Complement(props.userLanguage, props.userToken, params.orderId, onError, onSuccessFetch)
        if (props.listInvoicesComplement.finishedProcess) {
            setDisabledUploadComplement(true)
            setMissingComplements(true)
        } else {
            setMissingComplements(false)
        }
    }, [props.listInvoicesComplement.finishedProcess])// eslint-disable-line react-hooks/exhaustive-deps

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }
    const onSuccessFetch = () => {
        handleCloseBackdrop()
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    console.log(err.response.data)
                    break
                default:
                    break
            }
        }
    }

    const onChangeHandler = event => {
        if (checkFileType(event)) {
            setFile(event.target.files[0])
            setStatusNameComplementHidden(false)
            setNameComplement(event.target.files[0].name)
        } else {
            setStatusNameComplementHidden(true)
            setNameComplement('')
            setFile(null)
        }
    }

    const checkFileType = event => {
        let file = event.target.files[0]
        if (file != null) {
            let types = ['text/xml']

            if (types.every(type => file.type !== type)) {
                toast.error(file.type + " Formato no soportado", { className: classes.toastError })
                event.target.value = null
                return false
            } else {
                return true
            }
        }
    }

    const SendFile = () => {
        if (file != null) {
            handleOpenBackdrop()
            const formData = new FormData();
            formData.append('file', file);
            props.actions.Update_Complement(props.userLanguage, props.userToken, params.orderId, formData, onError, onSuccess)

            //Clear error
            setErrorComplementText('')
            setErrorComplementHidden(true)

            //Clear success
            setSuccessComplementList('')
            setSuccessComplementHidden(true)
        } else {
            toast.info("Selecciona un archivo")
        }
    }

    const onSuccess = (response) => {
        handleCloseBackdrop()
        if (response.status) {
            toast.success('Se agregó correctamente el complemento.', { className: classes.toastSuccess })

            setSuccessComplementList(response)
            setSuccessComplementHidden(false)

            //CLEAR
            Array.from(document.querySelectorAll("input")).forEach(
                input => (input.value = "")
            )
            ClearComplement()

            props.actions.fetch_Invoice_Complement(props.userLanguage, props.userToken, params.orderId, onError, onSuccessFetch)
            if (props.listInvoicesComplement.finishedProcess) {
                setDisabledUploadComplement(true)
            }
        } else {
            setErrorComplementText(response.message)
            setErrorComplementHidden(false)
        }
    }

    const ClearComplement = () => {
        Array.from(document.querySelectorAll('input')).forEach(
            input => (input.value = "")
        )

        setStatusNameComplementHidden(true)
        setNameComplement('')
        setFile(null)

        setErrorComplementText('')
        setErrorComplementHidden(true)
    }

    const ChangeOption = (e) => {
        switch (e) {
            case 'Complement':
                setButtonComplement(classes.GridBorderSelected)
                setButtonInvoice(classes.GridBorder)
                setStatusGridComplement(false)
                setStatusGridInvoice(true)
                setComplement(classes.TextSelected)
                setInvoice(classes.Text)
                setMissingComplementsGrid(false)
                break;
            case 'Invoice':
                props.actions.fetch_Invoice_Complement(props.userLanguage, props.userToken, params.orderId, onError, onSuccessFetch)
                setButtonComplement(classes.GridBorder)
                setButtonInvoice(classes.GridBorderSelected)
                setStatusGridComplement(true)
                setStatusGridInvoice(false)
                setComplement(classes.Text)
                setInvoice(classes.TextSelected)
                setMissingComplementsGrid(true)
                break;
            case 'Videos':
            default:
                break;
        }
    }
    return (
        <div>
            <TopBarNav />
            <br />

            <Container maxWidth="lg" >
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container>
                    <Grid item xs={4} style={{ marginLeft: '-25px' }}>
                        <BreadcrumbsHistory />
                    </Grid>
                    <Grid item xs={8}>
                        <h5>Subir complemento de pago</h5>
                    </Grid>
                </Grid>
            </Container>

            <Container maxWidth="lg" className={classes.root}>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={12} className={classes.dashboardAlign}>
                        <br />
                        <h6>Autorización: {params.orderId}</h6>
                        <h6>VIN: {props.orderDetail.vin}</h6>
                        <br />
                    </Grid>
                </Grid>

                <Grid container item xs={11} className={classes.ContainerBorder} style={{ height: '500px' }}>
                    <Grid item xs={3} className={classes.ContainerOptionBorder} >

                        <CardActionArea className={buttonComplement} onClick={(e) => ChangeOption("Complement")}>
                            <CardContent className={classes.dashboardAlign}>
                                <h5 className={textComplement}>Subir complemento</h5>
                            </CardContent>
                        </CardActionArea>

                        <CardActionArea className={buttonInvoice} onClick={(e) => ChangeOption("Invoice")} style={{ marginBottom: '5px' }}>
                            <CardContent className={classes.dashboardAlign}>
                                <h5 className={textInvoice}>Factura(s)</h5>
                            </CardContent>
                        </CardActionArea>

                    </Grid>
                    <Grid item xs={9} >
                        <Container maxWidth="lg" >
                            <Grid item xs={12} hidden={statusGridComplement}>
                                <br />
                                <Grid item xs={12} className={classes.dashboardAlign}>
                                    <Grid container item xs={12}>
                                        <Grid item xs={8}>
                                            <div className="form-group files">
                                                <label>Subir XML &nbsp;&nbsp;</label>
                                                <Input type="file" name="file" id="file" disabled={disabledUploadComplement} onChange={onChangeHandler} />
                                            </div>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
                                                <Button type="button" className={classes.ButtonSave} disabled={disabledUploadComplement} variant="outlined" onClick={SendFile}>Guardar</Button>
                                            </ButtonGroup>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container item xs={12} hidden={statusGridComplement}>
                                <Grid item xs={12} className={classes.dashboardAlign}>
                                    <Grid container item xs={12} hidden={statusNameComplementHidden}>
                                        <Grid item xs={7} style={{ textAlign: 'right', paddingTop: '15px', paddingright: '10px' }}>
                                            <label>{nameComplement}</label>
                                        </Grid>
                                        <Grid item xs={5} style={{ textAlign: 'left' }}>
                                            <IconButton aria-label="delete" style={{ color: '#C22727' }} onClick={ClearComplement}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <br />
                            <br />

                            <Grid container item xs={12} style={{ paddingTop: '70px' }} hidden={statusGridComplement}>
                                <Grid item xs={12} className={classes.dashboardAlign} hidden={errorComplementHidden}>
                                    <Grid container item xs={12} >
                                        <Grid item xs='auto' style={{ textAlign: 'right', paddingTop: '25px', paddingright: '20px' }}>
                                            <label>{errorComplementText}</label>
                                        </Grid>
                                        <Grid item xs={5} style={{ textAlign: 'left' }}>
                                            <CancelIcon style={{ color: 'red', fontSize: "5rem" }} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={classes.dashboardAlign} hidden={successComplementHidden}>
                                    <Grid container item xs={12} >
                                        <Grid item xs='auto' style={{ textAlign: 'left', paddingTop: '25px', paddingright: '20px' }}>
                                            {
                                                <label>{successComplementList.message}</label>
                                            }
                                            {
                                                successComplementList.invoiceList && successComplementList.invoiceList.map((item, index) => (
                                                    <div key={index + 1}>
                                                        <label> {index + 1 + ': '} &nbsp; {item} &nbsp; </label>
                                                        <br />
                                                    </div>
                                                ))
                                            }
                                        </Grid>
                                        <Grid item xs={5} style={{ textAlign: 'left' }}>
                                            <CheckCircleIcon style={{ color: 'green', fontSize: "5rem" }} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item xs={12} style={{ paddingTop: '70px' }} hidden={missingComplementsGrid}>
                                <Grid item xs={12} className={classes.dashboardAlign} hidden={missingComplements}>
                                    <Alert severity="warning">
                                        <AlertTitle>Faltan complementos por cargar.</AlertTitle>
                                    </Alert>
                                </Grid>
                            </Grid>


                            <Grid container item xs={12} hidden={statusGridInvoice} >
                                <Grid item xs={12} >
                                    <DataTable
                                        columns={getInvoiceComplementTableColumns("Maintenance")}
                                        data={props.listInvoicesComplement.invoiceComplement}
                                        defaultSortField=""
                                        noHeader={true}
                                        dense
                                        highlightOnHover
                                        pointerOnHover
                                        pagination
                                        paginationComponentOptions={paginationOptions}
                                    />
                                </Grid>
                            </Grid>
                        </Container>
                    </Grid>

                </Grid>
                <br />
                <br />
            </Container>
            <ToastContainer />
        </div>
    )

}

const mapStateToProps = state => ({
    userProfile: state.UserProfileReducer.list,
    orderDetail: state.MaintenanceReducer.orderDetail,
    listInvoicesComplement: state.MaintenanceReducer.listInvoicesComplement,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(maintenanceActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(MaintenanceStylesComplement)(MaintenanceUploadComplement))